module.exports = __webpack_public_path__ + "static/media/19ESCAP24.991bea67.jpg";